"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = (0, _keyMirror.default)({
  INITIAL_COMMUNICATOR_CONTENT_ENTRY: null,
  FLOATING_COMMUNICATOR_EXPAND_FULLSCREEN: null,
  FLOATING_COMMUNICATOR_FULLSCREEN_SAVE: null,
  QUOTE_SELECT: null
});

exports.default = _default;
module.exports = exports.default;